import axios from "axios";
import { API_BASE_URL, API_PATHS,getApiPaths } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class ClassandsectionService {



static getStandard(item) {
   
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.getStandard}`;
    if(item?.id)
    {
        api= `${API_BASE_URL}${API_PATHS.getStandard}?id=${item?.id}`;
    }
    return axiosInstance
        .get(api,item)
}


static getSection(item) {
   
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.getSection}`;
    if(item?.id)
    {
        api= `${API_BASE_URL}${API_PATHS.getSection}?id=${item?.id}`;
    }
    return axiosInstance
        .get(api,item)
}


}

export default ClassandsectionService;
